import './FormActionCondition.css';
import TextareaAutosize from 'react-textarea-autosize';
import TitleBlock from '../TitleBlock/TitleBlock';
import editorAction from '../../../actions/editorAction';
import { BlockActionConditionDefault } from '../../../data/constant/blocks/BlockActionConditionDefault';
import { useTreeStateContext } from '../../../contexts/TreeContext';
import binarySearchString from '../../../utils/binarySearchString';
import useErrorCheckEditor from '../../../hook/useErrorCheckEditor';
import { useTreeDispatchContext } from '../../../contexts/TreeContext';

function FormActionCondition({id}) {

    const { blocks, paths } = useTreeStateContext();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const block = blocks[indexBlock] ?  blocks[indexBlock] : BlockActionConditionDefault
    const { data } = block;
    const name = block.name;
    const dispatch = useTreeDispatchContext();

    const { checkErrorBlock } = useErrorCheckEditor()

    const { updateBlockData } = editorAction();

    const setTextareaData = (ref) => {
        if(!ref) {
            return null;
        }

        ref.value = data.condition
    }

    const onBlur = (e) => {
        const value = e.target.value;
        updateBlockData(id, { condition : value, name : name})
    }

    const onChange = (e) => {
        const value = e.target.value;
        dispatch({type : 'updateBlockData', payload : { id, data : { condition : value } }})
    }

    const errors = checkErrorBlock(block, { blocks, paths });
    var errorRaw = Object.entries(errors).filter( ([key, value]) => value.type == 'Wrong Spelling')

    var classNameInput = 'input editor-input title_input';
    classNameInput = errorRaw.length ? classNameInput + ' error' : classNameInput;

    return (
        <>
            <TitleBlock title="Condition" titleInput="Condition name" name={name} id={id}/>
            <div className='area-edit'>
                <label className="input_title">Type your condition : </label>
                <TextareaAutosize ref={(ref) => setTextareaData(ref)} onBlur={onBlur} onChange={onChange} className={classNameInput} placeholder='Example : [CALLER] == "0630981072" ' minRows={5}/>
                {errorRaw.length ? <span className='error'>{errorRaw[0][1].data}</span> : ''}
            </div>
        </>
    )
}

export default FormActionCondition;